// removed by extract-text-webpack-plugin
module.exports = {"tooltip":"tooltip_32E","tooltipVisible":"tooltipVisible_3CZ","tooltipInner":"tooltipInner_lom"};


//////////////////
// WEBPACK FOOTER
// ./src/components/tooltip/tooltip.scss
// module id = 619
// module chunks = 0 1